// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0LFDz","btns__con":"styles_btns__con__R7iC0"};